import { isSafeRedirect } from './navigator';

const KEY = 'curipod.postAuthRedirect';
const TTL_MS = 15 * 60 * 1000;

type Stored = { value: string; expiresAt: number };

export const savePostAuthRedirect = (value: string) => {
  if (typeof window === 'undefined') return;
  if (!isSafeRedirect(value)) return;
  try {
    const payload: Stored = { value, expiresAt: Date.now() + TTL_MS };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {}
};

export const readPostAuthRedirect = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Stored>;
    if (
      typeof parsed?.value !== 'string' ||
      typeof parsed?.expiresAt !== 'number' ||
      parsed.expiresAt < Date.now() ||
      !isSafeRedirect(parsed.value)
    ) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed.value;
  } catch {
    try {
      sessionStorage.removeItem(KEY);
    } catch {}
    return null;
  }
};

export const clearPostAuthRedirect = () => {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
};
